export type ParseZoomMeetingIdResult =
  | { ok: true; meetingId: string }
  | { ok: false };

const isUrlLike = (value: string) =>
  /^https?:\/\//i.test(value) || value.includes("zoom.us");

const isZoomHostname = (hostname: string) =>
  hostname === "zoom.us" || hostname.endsWith(".zoom.us");

export const parseZoomMeetingId = (value: string): ParseZoomMeetingIdResult => {
  const trimmed = value.trim();
  if (!trimmed) return { ok: true, meetingId: "" };

  if (isUrlLike(trimmed)) {
    try {
      const url = new URL(
        /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`,
      );
      if (!isZoomHostname(url.hostname)) {
        return { ok: false };
      }
      const segments = url.pathname.split("/").filter(Boolean);
      const joinIndex = segments.indexOf("j");
      if (joinIndex !== -1) {
        const meetingId = segments[joinIndex + 1];
        if (!meetingId) return { ok: false };
        return { ok: true, meetingId };
      }
      const meetingId = segments[segments.length - 1];
      if (!meetingId) return { ok: false };
      return { ok: true, meetingId };
    } catch {
      return { ok: false };
    }
  }

  return { ok: true, meetingId: trimmed };
};
